export const getDummyImageUrl = ({ backgroundColor = 'cccccc', height = 350, text = '', textColor = '000000', width = 350, }) => {
    const backgroundColorString = (backgroundColor
        ? `/${backgroundColor.replace('#', '')}/`
        : '');
    const textColorString = (textColor
        ? `${textColor.replace('#', '')}`
        : '');
    const textString = (text
        ? `?text=${text.replaceAll(' ', '+')}`
        : '');
    return `https://dummyimage.com/${width}x${height}${backgroundColorString}${textColorString}${textString}`;
};
